import { APIT } from 'utils';

const transformList = ({ data }) => data.map(item => ({
    ...item,
    startDate: APIT.date.in.toLocal(item.startDate),
    endDate: APIT.date.in.toLocal(item.endDate),
}));

export default transformList;
